import type { RouteKey } from '@/router/routesPathConfig';
import type { CompanyBankFeedDestinationKey } from '@/abilities/companyBankFeed/vocabulary';

/** The route that shows each place of the company Bank Feed page. */
export const companyBankFeedDestinationRoutes: Record<CompanyBankFeedDestinationKey, RouteKey> = {
  root: 'COMPANY_BANK_FEED',
  transactions: 'COMPANY_BANK_FEED_TRANSACTIONS',
  creditCards: 'COMPANY_BANK_FEED_CREDIT_CARDS',
};
